import React from "react";
import { Facebook, Instagram, Share2 } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import celebrationImage from "../../images/SS img.png"; // Using existing image

const CelebrationSection = ({
  title = "Celebrate your Birthday & Anniversary with the kids and make your celebration more joyous",
  tags = [
    { text: "Tax Benefit", link: "https://www.soodcharityfoundation.org/tax-benefit" },
    { text: "Urgent", link: "" },
    { text: "Life Event", link: "" }
  ],
  description = "Make your day fulfilling by celebrating with the kids. But sharing your happiness to needy and hungry poor people makes your celebration more joyous and happiness for yourself.",
  shareLinks = true,
}) => {
  // Get the current page URL for sharing
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const shareText = `Celebrate with Sood Foundation: ${title}`;
  
  // Share functions
  const handleShare = (platform) => {
    let shareUrl = '';
    
    switch(platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + ' ' + pageUrl)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(pageUrl)}`;
        break;
      case 'instagram':
        // Instagram doesn't have a direct share URL, but we can open Instagram and users can share manually
        shareUrl = 'https://www.instagram.com/sood_charity_foundation/?igsh=d2Y4eTdpYzc2dXow';
        break;
      default:
        return;
    }
    
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
  };

  // Helper function to get CSS class name from tag text
  const getTagClassName = (tagText) => {
    const normalizedText = tagText.toLowerCase().replace(/\s+/g, '-');
    return `tag tag-${normalizedText}`;
  };

  // Normalize tags array - handle both string arrays (backward compatibility) and object arrays
  const normalizedTags = tags.map(tag => {
    if (typeof tag === 'string') {
      return { text: tag, link: "" };
    }
    return tag;
  });

  return (
    <section className="celebration-hero-section">
      <div className="celebration-content">
        <div className="celebration-details">
          <h2 className="celebration-title">{title}</h2>

          <div className="celebration-tags">
            {normalizedTags.map((tag, index) => {
              const TagComponent = tag.link && tag.link.trim() ? 'a' : 'span';
              const tagProps = tag.link && tag.link.trim() 
                ? { 
                    href: tag.link, 
                    target: "_blank", 
                    rel: "noopener noreferrer",
                    className: getTagClassName(tag.text)
                  }
                : { 
                    className: getTagClassName(tag.text)
                  };
              
              return (
                <TagComponent key={index} {...tagProps}>
                  {tag.text === "Tax Benefit" && <Share2 size={14} />}
                  {tag.text}
                </TagComponent>
              );
            })}
          </div>

          <p className="celebration-description">{description}</p>

          {shareLinks && (
            <div className="share-section">
              <span className="share-label">Share :</span>
              <div className="share-buttons">
                <button 
                  onClick={() => handleShare('facebook')} 
                  className="share-btn facebook-btn"
                  aria-label="Share on Facebook"
                >
                  <Facebook size={18} />
                </button>
                <button 
                  onClick={() => handleShare('whatsapp')} 
                  className="share-btn whatsapp-btn"
                  aria-label="Share on WhatsApp"
                >
                  <FaWhatsapp size={18} />
                </button>
                <button 
                  onClick={() => handleShare('twitter')} 
                  className="share-btn twitter-btn"
                  aria-label="Share on X/Twitter"
                >
                  <FaXTwitter size={18} />
                </button>
                <button 
                  onClick={() => handleShare('instagram')} 
                  className="share-btn instagram-btn"
                  aria-label="Share on Instagram"
                >
                  <Instagram size={18} />
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="celebration-image-container">
          <img
            src={celebrationImage}
            alt="Celebration with kids"
            className="celebration-image"
          />
        </div>
      </div>
    </section>
  );
};

export default CelebrationSection;
